import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-light text-center py-3" style={{ position: 'absolute', bottom: '0', width: '100%' }}>
      <p>&copy; 2023 Brandboosters - Desarrollo y Marketing</p>
    </footer>
  );
}

export default Footer;
